/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Buttons from '../icons/button';

import styles from '../../../styles/partials/patched-link.scss';

const propTypes = {
    url: PropTypes.string,
    label: PropTypes.string,
    backgroundClassName: PropTypes.string,
    external: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    url: null,
    label: null,
    backgroundClassName: null,
    external: false,
    className: null,
};

const PatchedLink = ({ url, label, backgroundClassName, external, className }) => {
    const BackgroundPatch = Buttons.medium;
    const externalProps = external ? { target: '_blank', rel: 'noopener noreferrer' } : null;
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            <div className={styles.linkContainer}>
                {url ? (
                    <a
                        className={classNames(styles.label, {
                            [styles.hoverable]: url !== null,
                        })}
                        href={url}
                        {...externalProps}
                    >
                        <BackgroundPatch
                            className={classNames(styles.background, {
                                [backgroundClassName]: backgroundClassName !== null,
                            })}
                        />
                        <div className={styles.ellipsis}>
                            <span>{label}</span>
                        </div>
                    </a>
                ) : (
                    <div className={styles.label}>
                        <BackgroundPatch
                            className={classNames(styles.background, {
                                [backgroundClassName]: backgroundClassName !== null,
                            })}
                        />
                        <div className={styles.ellipsis}>
                            <span>{label}</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

PatchedLink.propTypes = propTypes;
PatchedLink.defaultProps = defaultProps;

export default PatchedLink;
